module.exports = ".action-button {\n  background-color: #fecc00;\n  color: #000;\n  font-size: 12px;\n  font-weight: bold;\n  letter-spacing: 0.3px;\n  padding: 7px 30px;\n  margin-left: 2px;\n  margin-right: 2px;\n}\n\n.color-red {\n  color: red !important;\n}\n\n::ng-deep .numberformat {\n  text-align: right;\n}\n\nli {\n  list-style: none;\n}\n\n.data {\n  text-align: right !important;\n}\n\n.input-email {\n  margin: 5px;\n}\n\n.other {\n  text-align: right;\n  margin-left: 25px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/system/retention/new-retention/new-retention.component.scss
// module id = ./src/app/system/retention/new-retention/new-retention.component.scss
// module chunks = main